module.exports = __webpack_public_path__ + "stylesheets/video-slider_3d9bdadc18dd53ab95e5ca9673ec446e.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/video-slider.less
// module id = KApX
// module chunks = 154